module.exports = __webpack_public_path__ + "img/logo-funtap.27a21f94.png";